export const memories = [
  {
    id: "qingkong",
    author: "青空",
    title: "重庆水o repo",
    excerpt: "在我平常不过的生活中，这是梦一样的三天，不想要结束啊。",
    paragraphs: [
      "月初第一次参加了Aqours only，就在南昌，是和三位同好一起参加的，给我的感受是，喜悦，期待，心跳加速，再次悸动起来了！月底在重庆也举办Aqours only，我们一拍即合缘分使然决定一起远征。",
      "这是我第一次远征参加only活动，出发前2天才确定可以去，现在回看，这个选择非常正确。我们挑选了民宿入住，把客厅完全装饰成了水水痛屋。每天晚上甚至根本没有困意，周日是aqours only，周六和周日晚上计划了前夜祭和后夜祭，一起打音游，看live，合唱勇气。两天晚上都搞到凌晨四点多才睡？！",
      "水o当天，是爬栏杆，站第一排的一天，收到了舞见老师的res，舞见老师指你的时候真的特别确定指的就是自己而不是身旁的其他人，就像触电一般，激动起来！第一次全程在第一排，舞台一览无余没有遮挡，是最极致的享受，起初站在第一排是有些羞涩的，后面就变得享受起来。八个多小时的演出，水水的经典曲目实在是太多了，一单君心，二单水族馆，op1青空，夺冠曲水蓝，思一……有哪位水水人会不在听到这些歌曲的前奏的时候心潮澎湃起来呢！舞台是很好的一方面，台下观众的应援是让我感动的另一大部分，尤其是永久hours和thank you friends的call，一起高呼 君も僕も 、輝こう、忘れないで，一起合唱，真是太棒了，独属于水水人的羁绊！感谢全体staff和dancer还有应援的水水人！",
      "水o后一天，气氛沉重起来，我们即将分开。不过下午还是一起出去转了转，下午3:30才出门，哈哈，去了鹅岭公园，一直走到李子坝，游客不太多，五点才到的所以太阳也刚刚好，很干净和宁静，有个塔可以俯瞰整个重庆，微微的轻风吹拂，好不自在。接下来运气好我们选择到了一家口味不错的重庆菜馆，用寝屋的话来说就是好吃到要哭出来了，我们在一个大堂里吃饭，离别气息渐浓，谈论的话题变成了等下该怎么赶车，只有我们在大堂，我外放了Over the Next Rainbow和Next Sparking作为背景音乐，歌词和旋律太应景了，如果时间停在此刻该多有好，明明就是三人一起吃饭的普通场景，却情不自禁有了要拿起相机记录下这一刻的冲动。",
      "在我平常不过的生活中，这是梦一样的三天，不想要结束啊。同好间诞生出了绚烂无比的羁绊，短暂相遇后，我们又各自踏上了自己的下一段旅程，在不久的以后再次相见吧，在不久的将来定会再次相遇的！2026的夏天，也有Aqours的陪伴，一个月内参加两场Aqours only，太棒了！！！",
    ],
  },
] as const;
